// extracted by mini-css-extract-plugin
export default {"socialicon":"footer_socialicon__YPbwJ","termscss":"footer_termscss__4j8+l","linkcss":"footer_linkcss__Wzoqj","mobilelink":"footer_mobilelink__pqNAt"};